import { render, staticRenderFns } from "./DematerialisationTab.vue?vue&type=template&id=f3b7eafc"
import script from "./DematerialisationTab.vue?vue&type=script&lang=js"
export * from "./DematerialisationTab.vue?vue&type=script&lang=js"
import style0 from "./DematerialisationTab.vue?vue&type=style&index=0&id=f3b7eafc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports